import { observable, decorate, computed, toJS } from "mobx";
import { getSurveyResponseValue } from "../../Helpers/General/SurveyResponsesHelper";

class IbsSurveyStore {
    currentSurvey = undefined;
    ibs_analyst = true;
    allTableResponses = {};
    mandateData = {};
    allResponses = [];
    allResponseErrorStates = [];
    adminForce = true;
    selectCombosTest = { "none": "none" }
    tableWidth = null
    tableSortConfigs = {}
    assetStylesForCat = {};
    filterTags = [];
    filterTagsNew = { "Product": [], "SurveyStatus": [], "dataYear": [] };
    styleOptions = [""];
    lastRowAdded = null;
    showAdminPanel = false;
    vintageYear = 2020;
    commitmentEndYear = null;
    mandateDataChanged = {};
    mandateTableInstance = null
    mandateCategoryToRender = "All"
    mandateSearchToRender = null
    assetCategoryToRender = "All"
    assetSearchToRender = null
    test = "blah"
    surveyCleanersIBS = null;
    surveyCleanersMapIBS = null;
    mandateInfo = {}
    showOptionalMandateColumns = false;
    lyMandataData = {}
    lyAssetData = {}
    hasMandateData = null;
    participantResult = null;
    universeResult = null;
    get mandateDataByCategory() {
        const result = this.mandateData.slice().reduce((prev, cur) => {
            if (!prev[cur.assetClassCategoryName]) {
                prev[cur.assetClassCategoryName] = [];
            }
            prev[cur.assetClassCategoryName].push(toJS(cur));
            return prev;
        }, {});
        return result;
    }
   

    get isEnhanced() {
        if (this.currentSurvey && [2, 3, 5, 6].includes(this.currentSurvey.EnhancedInternalID)) return true
        else return false
    }
    mandateModalInfo = { "ManagerName": "", "FundName": "", "AccountCode": "", "MandateID": "", "IsLgpsPoolOptions": false, "IsSingleMandate": true, "IsInCommitPeriod": false, "AssetClassID": "", "AssetClassName": "", "StyleName": "", "StyleID": "", "AssetCatID": "", "VintageYear": "", "LifeCycleStatus": "", "MandateRegionID": "", "MandateSubstyles": [], "RelativeRowNum": null, "commitmentEndYear": ""}
    dbStylesMap = {}
    dbDefaultCosts = {}
    /**
     * List of available surveys
     */
    surveyListDisplay = undefined;
    surveysHistorical = undefined;
    recentActivityList = undefined;
    surveySubmissionsByDate = undefined;
    productStatsDB = undefined;
    productStatsDC = undefined;
    mandateOnlyView = true;
    showAssetConfigureModal = null;
    showOptionRowModal = null;
    editOptionModal = false;
    legalStyles = []
    tempOptionsRowInfo = { "ProviderName": "", "OptionName": "", "AssetCategoryID": "", "AssetCategoryName": "", "MandateStyleID": "", "MandateStyleName": "", "OptionID": "", "MorningStarId": "", "Message": "", "Ticker": "", "ShareClass":"", "UseSecLend":""}
    showCustomiseTableOpts = true;
    showCustomiseTableOpts2 = false;
    isMandateDefaultsShown = false;
    hideTableTrigger = 0;
    sessionChanges = 0;
    get windowWidth() {
        console.log(window.innerWidth)
        return window.innerWidth;
    }
    get checkMandateLevel() {
        let isMandateLevel = getSurveyResponseValue("IsMandateLevel")
        if (isMandateLevel.toString()=="") isMandateLevel = null
        return isMandateLevel
    }
    defaultCoordinates = [];

    checkedSurvey = false;

    viewSurveyDetails = false;
    selectedSurvey = {};
    countriesForRegistration = {}
    /**
     * list of asset categories (has the display order in it)
     * @type {[]} list of asset class categories from database
     */
    assetClassCategories = [];
    defaultAssetStyleIDMap = {};

    templateDropdownData = {};
    templateNormalizedManagerDropdownData = {}
    templateLinkEntries = {};
    templateInProcess = [];
    templateExisting = [];
    templateExistingFirstLoad = true;

}

decorate(IbsSurveyStore, {
    templateNormalizedManagerDropdownData: observable,
    templateDropdownData: observable,
    templateLinkEntries: observable,
    templateInProcess: observable,
    templateExisting: observable,
    hideTableTrigger:observable,
    allResponseErrorStates:observable,
    mandateModalInfo: observable,
    allResponses: observable,
    accountInfo: observable,
    currentSurvey: observable,
    selectCombosTest: observable,
    windowWidth: computed,
    tableSortConfigs: observable,
    assetStylesForCat: observable, 
    styleOptions: observable,
    allTableResponses: observable, 
    surveyListDisplay: observable,
    surveysHistorical: observable,
    lastRowAdded: observable,
    showAdminPanel: observable,
    vintageYear: observable, 
    commitmentEndYear: observable, 
    hasMandateData:observable,
    mandateInfo: observable,
    mandateData: observable,
    mandateDataByCategory: computed,
    dbStylesMap: observable,
    dbDefaultCosts: observable,
    mandateDataChanged:observable,
    mandateOnlyView: observable,
    checkedSurvey: observable,
    viewSurveyDetails: observable,
    selectedSurvey: observable,
    isMandateDefaultsShown: observable,
    defaultAssetStyleIDMap: observable,
    surveyCleanersIBS: observable,
    surveyCleanersMapIBS: observable,
    mandateCategoryToRender: observable,
    mandateSearchToRender: observable,
    assetCategoryToRender: observable,
    assetSearchToRender: observable,
    showOptionRowModal : observable,
    showOptionalMandateColumns: observable,
    test: observable, 
    showAssetConfigureModal: observable,
    checkMandateLevel: computed,
    showCustomiseTableOpts: observable,
    showCustomiseTableOpts2: observable, 
    participantResult: observable, 
    universeResult: observable, 
    tempOptionsRowInfo: observable,
    legalStyles: observable,
    editOptionModal: observable,
    countriesForRegistration: observable, 
    sessionChanges:observable

});

export default new IbsSurveyStore();